export var ProgressBarColor;
(function (ProgressBarColor) {
    ProgressBarColor["RED"] = "RED";
    ProgressBarColor["BLUE"] = "BLUE";
    ProgressBarColor["GREEN"] = "GREEN";
    ProgressBarColor["ORANGE"] = "ORANGE";
})(ProgressBarColor || (ProgressBarColor = {}));
//# sourceMappingURL=ProgressBarColor.js.map